import { MigrationSelectedEndpoint } from '~/protos/agents'

// Endpoint interface for display and selection (simplified from backend)
export interface MigrationEndpoint {
  category: string // "HTTP", "SOAP", "EVENT"
  name: string // "GET /customer", "GetWeather", etc.
  file_loc: string // File path information
}

// Endpoint categories enum for filtering and display
export enum EndpointCategory {
  HTTP = 'HTTP',
  SOAP = 'SOAP',
  EVENT = 'EVENT'
}

// Category configuration for UI display
export interface EndpointCategoryConfig {
  category: EndpointCategory
  label: string
  color: string
  description: string
}

// Category display configurations
export const ENDPOINT_CATEGORY_CONFIGS: EndpointCategoryConfig[] = [
  {
    category: EndpointCategory.HTTP,
    label: 'HTTP',
    color: 'bg-blue-100 text-blue-800',
    description: 'REST API endpoints with HTTP methods'
  },
  {
    category: EndpointCategory.SOAP,
    label: 'SOAP',
    color: 'bg-green-100 text-green-800',
    description: 'SOAP web service operations'
  },
  {
    category: EndpointCategory.EVENT,
    label: 'EVENT',
    color: 'bg-purple-100 text-purple-800',
    description: 'Event triggers and scheduled jobs'
  }
]

// Helper function to get category config
export const getCategoryConfig = (category: string): EndpointCategoryConfig => {
  return (
    ENDPOINT_CATEGORY_CONFIGS.find(config => config.category === category.toUpperCase()) || {
      category: category.toUpperCase() as EndpointCategory,
      label: category.toUpperCase(),
      color: 'bg-gray-100 text-gray-800',
      description: 'Other endpoint type'
    }
  )
}

// Helper function to convert MigrationEndpoint to MigrationSelectedEndpoint
export const toSelectedEndpoint = (endpoint: MigrationEndpoint): MigrationSelectedEndpoint => {
  return {
    category: endpoint.category,
    name: endpoint.name,
    filePath: endpoint.file_loc
  }
}

// Helper function to create unique key for endpoint
export const createEndpointKey = (endpoint: MigrationEndpoint): string => {
  return `${endpoint.category.trim().toUpperCase()}:${endpoint.name.trim()}`
}

// Props for endpoint selection component
export interface EndpointSelectionProps {
  endpoints: MigrationEndpoint[]
  selectedEndpoints: MigrationEndpoint[]
  onSelectionChange: (selectedEndpoints: MigrationEndpoint[]) => void
  onSubmit: (selectedEndpoints: MigrationSelectedEndpoint[]) => void
  isSubmitting: boolean
  showSubmitButton?: boolean
}

// Props for individual endpoint item component
export interface EndpointItemProps {
  endpoint: MigrationEndpoint
  isSelected: boolean
  onToggle: (endpoint: MigrationEndpoint, selected: boolean) => void
}
